import httpUtil from '@/utils/httpUtil'

/** 今日概况 */
export const situationStatistics = params =>
  httpUtil.post('/api/crmPc/radar/situationStatistics', params)

/** 趋势 */
export const timeStatistics = params =>
  httpUtil.post('/api/crmPc/radar/timeStatistics', params)

/** 场景 */
export const sceneStatistics = params =>
  httpUtil.post('/api/crmPc/radar/sceneStatistics', params)

/** 访问排行 */
export const getVisitRankingList = params =>
  httpUtil.post('/api/crmPc/radar/getVisitRankingList', params)

/** 分享概况 */
export const shareSituation = params =>
  httpUtil.post('/api/crmPc/radar/shareSituation', params)

/** 分享排行 */
export const shareTopN = params =>
  httpUtil.post('/api/crmPc/radar/shareTopN', params)

/** 成交转化漏斗 */
export const getChangeCount = params =>
  httpUtil.post('/api/crmPc/radar/getChangeCount', params)
